var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountLine = function SvgAccountLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.593 14.225C5.168 12.82 7.47 11.95 10 11.95s4.832.862 6.409 2.276a.625.625 0 1 1-.835.931C14.252 13.971 12.256 13.2 10 13.2c-2.254 0-4.252.779-5.576 1.958a.625.625 0 1 1-.831-.933M7.233 7.858a2.767 2.767 0 1 1 5.534 0 2.767 2.767 0 0 1-5.534 0M10 6.342a1.517 1.517 0 1 0 0 3.033 1.517 1.517 0 0 0 0-3.033"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.667 10a8.333 8.333 0 1 1 16.666 0 8.333 8.333 0 0 1-16.666 0M10 2.917a7.083 7.083 0 1 0 0 14.166 7.083 7.083 0 0 0 0-14.166"
  })));
};
export default SvgAccountLine;